import { setPageTitle, detectDeviceMobile, isProduction } from "@/utils";
import Vue from "vue";
import VueRouter from "vue-router";
// import { zh_init } from "@/utils/zh.js";
Vue.use(VueRouter);

let routes: any[] = [];
function importAll(r: any) {
  r.keys().forEach((key: string) => {
    routes = routes.concat(r(key).default);
  });
}

importAll(require.context("./routes/", true, /\.ts$/));

const router = new VueRouter({
  scrollBehavior(to, from, savedPosition) {
    //to top

    return { x: 0, y: 0 };
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "首页",
      component: () => import("@/views/Layout.vue"),
      children: routes
    },
    {
      path: "*",
      redirect: { path: "/" }
    }
  ]
});
router.beforeEach((to, from, next) => {
  //to and from are Route Object,next() must be called to resolve the hook}
  // document.title = "集盒商学官网-" + (to.meta && to.meta.title);
  // zh_init();
  setPageTitle(to.name || "光华赋能");
  let isPro = isProduction();
  // if (isPro && window.location.protocol === "https:") {
  //   // alert('请使用https访问')
  //   window.location.href = window.location.href.replace("https:", "http:");
  //   return;
  // }
  console.log("🚀 ~ document.location.protocol:", document.location.protocol);
  if (detectDeviceMobile()) {
    window.location.href =
      document.location.protocol + "//m.myguanghua.com" + to.fullPath;

    return;
  }
  next();
});
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    // window.$zh_tran(window.$getCookie("zh_choose"));
    // window.$zh_init();
  });
});
export default router;
